import * as React from 'react';

import classNames from 'classnames';

import { Link as BaseLink, ILinkProps as IBaseLinkProps } from '@base/components/ui';

import * as s from './Link.scss';

interface ILinkProps extends IBaseLinkProps {}

export const Link: React.FC<ILinkProps> = (props: ILinkProps ) => {
	return <BaseLink {...props} className={classNames(s.block, props.className)}/>;
};
